module.exports = __webpack_public_path__ + "img/c05_unitonager_Normal_ua.e3ed1312.webp";